import { 
    APPLICATION_STATUS_UNREAD,
    APPLICATION_STATUS_UNDER_REVIEW,
    APPLICATION_STATUS_PENDING,
    APPLICATION_STATUS_APPROVED_ISSUED,
    APPLICATION_STATUS_DENIED,
    APPLICATION_STATUS_PENDING_AGENCY,
    APPLICATION_STATUS_OPENED,
    APPLICATION_STATUS_WITHDRAWN_BY_CLIENT,
    APPLICATION_STATUS_WITHDRAWN_APPROVED,
    LICENCE_STATUS_ACTIVE,
    LICENCE_STATUS_EXPIRED,
    LICENCE_STATUS_SUSPENDED,
    LICENCE_STATUS_REVOKED,
    LICENCE_STATUS_WITHDRAWN,
    LICENCE_STATUS_WITHDRAWN_BY_CLIENT,
    LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION
} from '../../../app/constants'

import "./ApplicationStatus.styles.scss"

export default function ApplicationStatusComponent({applicationStatus, licencingSubType, licenceStatus}){ 
    let elem = null

    switch(applicationStatus) {
        case APPLICATION_STATUS_APPROVED_ISSUED : 
            elem = (
                <div className="licence-status-approved">
                    <i className="fa fa-check-circle fa-lg"></i>
                    <span className="licence-status-text">Approved</span>
                </div>)
        break
        case APPLICATION_STATUS_DENIED : 
            elem = (
                <div className="licence-status-denied">
                    <i className="fa fa-times-circle fa-lg"></i>
                    <span className="licence-status-text">Denied</span>
                </div>
            )
        break
        case APPLICATION_STATUS_WITHDRAWN_BY_CLIENT : 
            elem = (
                <div className="licence-status-withdrawn">
                    <i className="fa fa-exclamation-circle fa-lg"></i>
                    <span className="licence-status-text">Cancelled by client</span>
                </div>
            )
        break
        case APPLICATION_STATUS_WITHDRAWN_APPROVED : 
        
            if(licenceStatus === LICENCE_STATUS_WITHDRAWN_BY_CLIENT){
                elem = (
                    <div className="licence-status-denied">
                        <i className="fa fa-times-circle fa-lg"></i>
                        <span className="licence-status-text">Cancelled by client</span>
                    </div>
                )
            }
            else {
                elem = (
                    <div className="licence-status-withdrawn">
                        <i className="fa fa-exclamation-circle fa-lg"></i>
                        <span className="licence-status-text">Cancelled</span>
                    </div>
                )
            }
        
        break;
        case APPLICATION_STATUS_UNREAD : 
            elem = (
                <div className="licence-status-unread">
                    <i className="fa fa-envelope fa-lg"></i>
                    <span className="licence-status-text">Unread</span>
                </div>)
        break
        case APPLICATION_STATUS_PENDING : 
            elem = (
            <div className="licence-status-pending">
                <i className="fa fa-clock-o fa-lg"></i>
                <span className="licence-status-text">Pending</span>
            </div>)
        break
        case APPLICATION_STATUS_PENDING_AGENCY : 
            if(licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION) {
                elem = (
                    <div className="licence-status-pending">
                        <i className="fa fa-clock-o fa-lg"></i>
                        <span className="licence-status-text">Pending principal broker</span>
                    </div>)
            } else {
                elem = (
                    <div className="licence-status-pending">
                        <i className="fa fa-clock-o fa-lg"></i>
                        <span className="licence-status-text">Pending agency approval</span>
                    </div>)
            }
        break
        case APPLICATION_STATUS_OPENED : 
            elem = (
            <div className="licence-status-opened">
                <i className="fa fa-envelope-open fa-lg"></i>
                <span className="licence-status-text">Opened</span>
            </div>   
            )
        break
        case APPLICATION_STATUS_UNDER_REVIEW :
            elem = (
            <div className="licence-status-under_review">
                <i className="fa fa-exclamation-triangle fa-lg"></i>
                <span className="licence-status-text">Under Review</span>
            </div>)
        break;
        case LICENCE_STATUS_ACTIVE :
            elem = (
                <div className="licence-status-approved">
                    <i className="fa fa-check-circle fa-lg"></i>
                    <span className="licence-status-text">Active</span>
                </div>)
        break
        case LICENCE_STATUS_EXPIRED : 
            elem = (
                <div className="licence-status-denied">
                    <i className="fa fa-times-circle fa-lg"></i>
                    <span className="licence-status-text">Expired</span>
                </div>
            )
        break
        case LICENCE_STATUS_SUSPENDED : 
            elem = (
                <div className="licence-status-denied">
                    <i className="fa fa-times-circle fa-lg"></i>
                    <span className="licence-status-text">Suspended</span>
                </div>
            )
        break
        case LICENCE_STATUS_REVOKED : 
            elem = (
                <div className="licence-status-denied">
                    <i className="fa fa-times-circle fa-lg"></i>
                    <span className="licence-status-text">Revoked</span>
                </div>
            )
        break
        case LICENCE_STATUS_WITHDRAWN : 
            elem = (
                <div className="licence-status-denied">
                    <i className="fa fa-times-circle fa-lg"></i>
                    <span className="licence-status-text">Cancelled</span>
                </div>
            )
        break
        case LICENCE_STATUS_WITHDRAWN_BY_CLIENT : 
            elem = (
                <div className="licence-status-denied">
                    <i className="fa fa-times-circle fa-lg"></i>
                    <span className="licence-status-text">Cancelled by client</span>
                </div>
            )
        break
        default :
            elem = (
            <div className="licence-status-under_review">
                <i className="fa fa-exclamation-triangle fa-lg"></i>
                <span className="licence-status-text">Under Review</span>
            </div>) 
        break
    }

    return elem
}